export default {
    computed: {
        ui() {
            return this.$store.state.ui;
        },
        notifications() {
            return this.$store.state.notifications;
        },
        user() {
            return this.$store.state.user;
        },
        settings() {
            return this.$store.state.settings;
        },
        isAdmin() {
            return parseInt(this.$store.state.user.kind) === 255 || parseInt(this.$store.state.user.kind) === 112;
        },
        isProfessor() {
            return parseInt(this.$store.state.user.kind) === 1;
        },
        isStudent() {
            return parseInt(this.$store.state.user.kind) === 2;
        },
        studentBachelorOrMaster() {
            // // * if user not exists returns 0
            // // * if Student is Bachelor returns 1
            // // * if Student is Master returns 2,3,4
            // // *  ΠΜΣ1: 2 (Εφυης)
            // // *  ΠΜΣ2: 3 (Ηλεκτρονικά)
            // // *  PhD: 4
            // // *  etc
            // // * Check if is Master when returns >=2
            // if (this.$store.state.user.am.indexOf("Dr") != -1) return 4;
            // //if (this.$store.state.user.am.indexOf("/") == 2) return 2;
            // if (this.$store.state.user.am.indexOf("m") != -1 && this.$store.state.user.am.indexOf('5') == 0 && this.$store.state.user.am.length == 6 ) return 3;
            
            // if(this.$store.state.user.am.indexOf('/') == 1 || this.$store.state.user.am.indexOf('/') == 2 || this.$store.state.user.am.length == 6) return 2;
            // //ΠΜΣ2:  5/2020, 15/2022, 152022
            // return 1;

            if(this.$store.state.user.am.indexOf('Dr') != -1) return 4;
            if(this.$store.state.user.am.indexOf('m') != -1 && this.$store.state.user.am.indexOf('5') == 0 && this.$store.state.user.am.length == 6) return 3;
            //if(user[0].am.indexOf('/') == 1 || user[0].am.indexOf('/') == 2 || user[0].am.length == 6) return 2;
            if(this.$store.state.user.am.indexOf('/') == 1 || this.$store.state.user.am.indexOf('/') == 2 && (this.$store.state.user.am.length == 6 || this.$store.state.user.am.length == 7)) return 2;
            if(this.$store.state.user.am[0] == 0 || this.$store.state.user.am[0] == 1 || this.$store.state.user.am[0] == 2 || this.$store.state.user.am[0] == 3 && 
               (this.$store.state.user.am.indexOf('2021') !=-1 || this.$store.state.user.am.indexOf('2022') !=-1
               || this.$store.state.user.am.indexOf('2023') !=-1 || this.$store.state.user.am.indexOf('2024') !=-1 || this.$store.state.user.am.indexOf('2025') !=-1) 
               && this.$store.state.user.am.indexOf('/') == -1 && this.$store.state.user.am.length == 6) return 2;

            //return this.$store.state.user.remote_id;
          },
        __watcher_logged_in() {
            return (this.user.token !== null && String(this.settings.user).trim() !== "");
        },
        __watcher_html_lang() {
            return this.ui.window.language;
        },
        __watcher_html_theme() {
            return this.ui.window.theme;
        }
    },
    methods: {
        displayStudents(statustext,st1,st2){
            if(st1 == null) st1 = '';
            if(st2 == null) st2 = '';
            if(st1 != null || st2 != null)
            return this.Translate(statustext)+"<br><span style='font-size: 10px;'>"+st1+"<br>"+st2+"</span>";
        },
        typeOfThesisText(type) {
            if(type == 0)return "(Δ) Διπλωματική";
            if(type == 1)return "(Π) Πτυχιακή";
            if(type == 2)return "(ΠΜΣ1) Διπλωματική - Ευφυείς Τεχνολογίες Διαδικτύου";
            if(type== 3)return "(ΠΜΣ2) Διπλωματική - Εφαρμοσμένα Ηλεκτρονικά Συστήματα";
            if(type== 4)return "Διδακτορική Διατριβή";
        },       
        typeOfThesisTextMin(type) {
            if(type == 0)return "Δ";
            if(type == 1)return "Π";
            if(type == 2)return "ΠΜΣ1";
            if(type== 3)return "ΠΜΣ2";
            if(type== 4)return "PhD";
        },  
        ShowAlert(type, text, timeout) {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
            this.ui.alert = {
                type: type,
                text: text
            };
            setTimeout(() => {
                this.ui.alert = {
                    type: "",
                    text: ""
                };
            }, timeout);
        },
        ReloadPage() {
            this.$router.go().catch(err => {
                console.log(err);
            });
        },
        Translate(data) {
            if (typeof this.ui.translations[data] !== "undefined" && typeof this.ui.translations[data][this.ui.window.language] !== "undefined") {
                return this.ui.translations[data][this.ui.window.language]
            } else {
                return String(data).replaceArray(["@", "_"], ["", " "]).toLowerCase();
            }
        }
    },
    watch: {
        __watcher_html_lang(newValue, oldValue) {
            if (newValue !== oldValue) {
                document.documentElement.lang = String(newValue).trim().toLowerCase();
                this.$store.dispatch("http_get_translations");
            }
        },
        __watcher_html_theme(newValue, oldValue) {
            if (newValue !== oldValue) {
                if (String(newValue).trim().toLowerCase() === 'dark') {
                    document.body.classList.add("dark");
                } else {
                    document.body.className = document.body.className.replace("dark", "");
                }
            }
        }
    },
    created() {},
    destroyed() {}
};